// extracted by mini-css-extract-plugin
export var readonly = "_iv-1";
export var star = "_iv-0";